var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container error-container",attrs:{"id":"raudio-app"}},[_c('div',[_c('h1',[_c('img',{staticClass:"img",attrs:{"src":"/static/images/bucket-empty.svg"}}),_vm._v(" Page not found ")])])])
}]

export { render, staticRenderFns }